import { Controller } from "@hotwired/stimulus";
import i18n from '../init/i18n';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  static targets = ["content", "copyBtn"];

  copy(event) {
    navigator.clipboard.writeText(this.contentTarget.textContent);

    this.copyBtnTarget.setAttribute("data-bs-original-title", i18n.t('copy_to_clipboard'));

    const btnTooltip = bootstrap.Tooltip.getOrCreateInstance(this.copyBtnTarget, {
      trigger: "manual"
    });

    btnTooltip.show();

    setTimeout(() => btnTooltip.hide(), 2000);
  }
}
